
export const categories=[
    {
        name:'Bags',
        value:'BAG'
    },    
    {
        name:'Accessories',
        value:'ACCESSORIES'
    },
    {
        name:'Luggage',
        value:'LUGGAGE'
    }
]


// WEBPACK FOOTER //
// ./src/mockup/categories.ts